import {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import CountryShow from './country-show';
import CountryForm from './country-form';

function CountryPage() {
  const navigate = useNavigate();
  const {countryId} = useParams();
  const isNew = countryId === 'new';
  const [mode, setMode] = useState(isNew ? 'edit' : 'show');
  // Used to force-remount CountryShow after a successful save so it refetches.
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    if (!isNew) setMode('show');
  }, [countryId, isNew]);

  const goToList = () => navigate('/contacts/countries');

  if (isNew) {
    return (
      <CountryForm
        countryId="new"
        onCancel={goToList}
        onSaved={(saved) => {
          if (saved?.id) navigate(`/contacts/countries/${saved.id}`);
          else goToList();
        }}
      />
    );
  }

  if (mode === 'show') {
    return (
      <CountryShow
        key={`show-${reloadKey}`}
        countryId={countryId}
        onEdit={() => setMode('edit')}
        onList={goToList}
      />
    );
  }

  return (
    <CountryForm
      countryId={countryId}
      onCancel={() => setMode('show')}
      onSaved={() => {
        setReloadKey((k) => k + 1);
        setMode('show');
      }}
    />
  );
}

export default CountryPage;
